import React, { useState, useEffect } from "react";

import SideNavigation from "@amzn/awsui-components-react/polaris/side-navigation";
import { useHistory, useLocation } from "react-router-dom";
import { FLEXICO_TEMPLATE_KEYS } from "./Constants";

export default (props) => {
  const [activeHref, setActiveHref] = useState(props.activeHref);
  const history = useHistory();
  const location = useLocation();
  const [items, setItems] = useState([
    {
      "type": "link",
      "text": "Back",
      "href": props.back?`/${props.back}`:`/App/${props.id}`
    }
  ])
  const [name, setName] = useState('')
  const [href, setHref] = useState('')

  const getDisplayName = () => {
    const params = new URLSearchParams(location.search);
    const aliasParam = params.get('alias');
    if (aliasParam) {
      return aliasParam; // Use the alias parameter value directly (e.g., "2.2")
    }
    // If no alias parameter, return the original template name
    return props?.process?.[FLEXICO_TEMPLATE_KEYS.template_name] || '';
  }

  useEffect(() => {
    if (props?.process?.hasOwnProperty(FLEXICO_TEMPLATE_KEYS.template_name)) {
      const displayName = getDisplayName();
      document.title = `Accounting Central - Flexico, ${displayName}`
      setName(displayName)
    }
      
      // Get alias parameter to propagate to navigation links
      const params = new URLSearchParams(location.search);
      const aliasParam = params.get('alias');
      const viewAsParam = params.get('view_as');
      const aliasQuery = (aliasParam ? `&alias=${aliasParam}` : '') + (viewAsParam ? `&view_as=${viewAsParam}` : '');
      
      let hrefPrefix = `/App/${props.id}/flexico/${props.fid}`
      setHref(hrefPrefix)
      let items = [
        {
          "type": "link",
          "text": "History",
          "href": props.back?`${hrefPrefix}/history?back=${props.back}${aliasQuery}`:`${hrefPrefix}/history${aliasParam ? `?alias=${aliasParam}` : ''}${viewAsParam ? `${aliasParam ? '&' : '?'}view_as=${viewAsParam}` : ''}`
        }, 
        {
          "type": "link",
          "text": "Execute",
          "href": props.back?`${hrefPrefix}/upload?back=${props.back}${aliasQuery}`:`${hrefPrefix}/upload${aliasParam ? `?alias=${aliasParam}` : ''}${viewAsParam ? `${aliasParam ? '&' : '?'}view_as=${viewAsParam}` : ''}`
        },
        {
          "type": "link",
          "text": "Details",
          "href":  props.back?`${hrefPrefix}?back=${props.back}${aliasQuery}`:`${hrefPrefix}${aliasParam ? `?alias=${aliasParam}` : ''}${viewAsParam ? `${aliasParam ? '&' : '?'}view_as=${viewAsParam}` : ''}`
        },
        {
          "type": "link",
          "text": "FlexiCo template Audit logs",
          "href":  props.back?`${hrefPrefix}/FlexicoProcessAuditLogs?back=${props.back}${aliasQuery}`:`${hrefPrefix}/FlexicoProcessAuditLogs${aliasParam ? `?alias=${aliasParam}` : ''}${viewAsParam ? `${aliasParam ? '&' : '?'}view_as=${viewAsParam}` : ''}`
        },
        { type: "divider" },
        {
          "type": "link",
          "text": "Back",
          "href": props.back?`/${props.back}`:`/App/${props.id}`
        },
      ];
      setItems(items)


  }, [props, location.search])

  useEffect(()=>{
    return () =>{
      document.title = 'Accounting Central'
    }
  }, [])

  return (
    <SideNavigation
      activeHref={activeHref}
      header={{ href: href, text: name }}
      onFollow={e => {
        e.stopPropagation();
        e.preventDefault();
        history.push(e.detail.href);
        setActiveHref(e.detail.href)
      }}
      items={items}
    />
  );
}
